<template>
  <Modal v-if="visible" :value="true" @input="closeModal" width="sm">
    <div slot="header">
      Nova tabela
    </div>
  
    <div class="row">
      <div class="col-md-4">
        <label class="float-right">Layout</label>
      </div>
      <div class="col-md-8">
        <input :value="schema.name" class="form-control" disabled="disabled">
      </div>
    </div>
  
    <div class="row mt-1">
      <div class="col-md-4">
        <label class="float-right">Nome da Tabela</label>
      </div>
      <div class="col-md-8">
        <input v-model="table.name" class="form-control">
      </div>
    </div>
  
    <div class="row mt-1">
      <div class="col-md-4">
        <label class="float-right">Descrição</label>
      </div>
      <div class="col-md-8">
        <textarea v-model="table.description" class="form-control" rows="5"/>
      </div>
    </div>
  
    <div class="row mt-1">
      <div class="col-md-4">
        <label class="float-right">Pública</label>
      </div>
      <div class="col-md-8">
        <input type="checkbox" v-model="table.public"/>
      </div>
    </div>
  
    <hr>
    <div class="row mt-1">
      <div class="col-md-12 text-center">
        <button class="btn btn-outline mr-3 px-4" @click="closeModal">
          Cancelar
        </button>
  
        <button @click="save" class="btn btn-primary px-4">
          Salvar
        </button>
      </div>
    </div>
    
  </Modal>
</template>

<script>
import Modal from '@/components/shares/specialTag/Modal'
import ModelMapper from '@/mixins/ModelMapper'

export default {
  components: { Modal },
  computed: {
    visible() {
      return this.value
    }
  },
  data: () => ({
    modelPathPrefix: 'custom_table',
    nameModel: 'Table',
    table: {
      schemaId: null
    },
  }),
  methods: {
    closeModal() {
      this.$emit('input', false)
    },
    save() {
      this.asyncTemplateSave(this.table, {
        after: ({model}) => this.$router.push(`/custom_table/tables/${model.id}`)
      })
    }
  },
  mixins: [ModelMapper],
  name: 'NewTable',
  props: {
    schema: { required: true, type: Object },
    value: { default: false, type: Boolean }
  },
  watch: {
    visible(value) {
      if (value)
        this.table.schemaId = this.schema.id
    }
  }
}
</script>

<style scoped>

</style>